type affiliateData = {
    name?: string,
    affiliateName: string,
    affiliateNumber: string,
    affNumbers?: string,
    subAffiliate: affiliateData[] | []
}

type dropdownData = {
    label: string,
    value: string,
    subAffiliate?: affiliateData[]
}

export const GetDropdownFormat = (data: affiliateData[] = []) => {
    let dropdownFormat: dropdownData[] | [] = [];
    if (data.length > 0) {
        dropdownFormat = data.map((affiliate: affiliateData) => ({
            label: affiliate.name ? affiliate.name : affiliate.affiliateName,
            value: affiliate.affNumbers ? affiliate.affNumbers : affiliate.affiliateNumber,
            ...(affiliate.subAffiliate && {
                subAffiliate: affiliate.subAffiliate?.length > 0 ?
                    GetDropdownFormat(affiliate.subAffiliate) : affiliate.subAffiliate
            })
        }));
    }
    return dropdownFormat;
}